import React from "react";
import { Box, Paper, Typography, Grid } from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import { theme } from "../../../Theme";
import { PROMO_COLORS } from "../constants/colors";

function KPICard({ label, value, unit = "", trend }) {
  const isPositive = trend === "up";
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: 2,
        border: "1px solid #F2F4F7",
        height: "100%",
      }}
    >
      <Typography
        variant="caption"
        color="text.secondary"
        display="block"
        mb={0.5}
      >
        {label}
      </Typography>
      <Box display="flex" alignItems="center" gap={0.5}>
        <Typography
          variant="h6"
          fontWeight={700}
          color={theme.palette.primary.main}
        >
          {value}
          {unit}
        </Typography>
        {trend && (
          isPositive ? (
            <TrendingUpIcon
              sx={{ color: PROMO_COLORS.safe, fontSize: 18 }}
            />
          ) : (
            <TrendingDownIcon
              sx={{ color: PROMO_COLORS.threat, fontSize: 18 }}
            />
          )
        )}
      </Box>
    </Paper>
  );
}

function isPromoApiKpis(kpis = {}) {
  return (
    kpis.expectedVolumeL != null ||
    kpis.upliftRatio != null ||
    kpis.expectedProfit != null ||
    kpis.promoPricePerLiter != null
  );
}

function fmtFixed(val, decimals = 2) {
  if (val === undefined || val === null || Number.isNaN(Number(val))) {
    return "—";
  }
  return Number(val).toFixed(decimals);
}

export default function KPICards({ kpis = {} }) {
  const fmt = (val, divisor = 1) =>
    val !== undefined && val !== null && !Number.isNaN(Number(val))
      ? divisor > 1
        ? `${(val / divisor).toFixed(0)}K`
        : val
      : "—";

  if (isPromoApiKpis(kpis)) {
    const roiDisplay =
      kpis.roi === null || kpis.roi === undefined
        ? "—"
        : fmtFixed(kpis.roi);

    const apiCards = [
      {
        label: "Expected volume (L)",
        value: fmtFixed(kpis.expectedVolumeL),
      },
      {
        label: "Uplift ratio",
        value:
          kpis.upliftRatio == null ? "—" : `${fmtFixed(kpis.upliftRatio)}×`,
      },
      {
        label: "Expected profit",
        value: fmtFixed(kpis.expectedProfit),
      },
      {
        label: "Discount spend",
        value: fmtFixed(kpis.discountSpend),
      },
      {
        label: "Cannibalization",
        value: fmtFixed(kpis.cannibalizationValue),
      },
      {
        label: "Margin impact",
        value: fmtFixed(kpis.marginImpact),
      },
      {
        label: "ROI",
        value: roiDisplay,
      },
      {
        label: "Promo price / L",
        value: fmtFixed(kpis.promoPricePerLiter),
      },
      {
        label: "Promo price / unit",
        value: fmtFixed(kpis.promoPriceUnit),
      },
    ];

    return (
      <Grid container spacing={2}>
        {apiCards.map((c) => (
          <Grid item xs={12} sm={6} md={4} key={c.label}>
            <KPICard {...c} />
          </Grid>
        ))}
      </Grid>
    );
  }

  const cards = [
    {
      label: "ROI",
      value: fmt(kpis.roi),
      unit: "x",
      trend:
        kpis.roi != null && kpis.roi >= 1.5 ? "up" : "down",
    },
  ];

  return (
    <Grid container spacing={2}>
      {cards.map((c) => (
        <Grid item xs={6} sm={4} md={2} key={c.label}>
          <KPICard {...c} />
        </Grid>
      ))}
    </Grid>
  );
}
